import React from 'react';

import { CryptoAccountTransactionDetailsItem } from '@/components/molecules/CryptoAccountTransactionDetailsItem';
import { FiatAccountTransactionDetailsItem } from '@/components/molecules/FiatAccountTransactionDetailsItem';
import { BitsoBank } from '@/types/bitsoBank';
import { Account, isFiatAccount } from '@/types/contacts';

interface Props {
  readonly account: Account | null;
  readonly banks: readonly BitsoBank[];
}

export const AccountTransactionDetailsItem: React.FC<Props> = (
  props: Props,
): React.ReactElement => {
  const { account, banks } = props;

  if (account === null) {
    console.debug('AccountTransactionDetailsItem: account is null');
    return <></>;
  }

  if (!isFiatAccount(account)) {
    return <CryptoAccountTransactionDetailsItem account={account} />;
  } else {
    return <FiatAccountTransactionDetailsItem account={account} banks={banks} />;
  }
};
